<template>
    <div style="display:inline-block;">

        <v-popover
            offset="16"
            :options="options"
            style="display:inline-block;"
            :open="show"
            placement="left"
        >
            <!-- This will be the popover target (for the events and position) -->
            <button class="tooltip-target b3" style="display:inline-block;" @mouseover="show = true" @mouseleave="show = false">
                <i class="fas fa-calculator fa-fw" />
                <span v-if="closed">
                    <div
                        class="coverage-indicator"
                        :class="{'bad': project.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(project.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(project.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                    />
                </span>
            </button>

            <!-- This will be the content of the popover -->
            <template slot="popover">

                <div v-if="minubaBudget && !loading">

                    <table style="white-space:nowrap;margin:0 -10px;font-size:12px;" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th align="left" style="padding:3px 10px;">Navn</th>
                                <!--<th align="right" style="padding:3px 10px;">Nr.</th>-->
                                <th align="right" style="padding:3px 10px;">Tilbud</th>
                                <th align="right" style="padding:3px 10px;">Ordre</th>
                                <!--<th align="right" style="padding:3px 10px;">Reguleringer</th>
                                <th align="right" style="padding:3px 10px;">Revideret</th>-->
                                <th align="right" style="padding:3px 10px;">Realiseret til dato</th>
                                <th align="right" style="padding:3px 10px 3px 20px;font-style:italic;">Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td align="left" style="padding:3px 10px;">Omsætning</td>
                                <!--<td align="right" style="padding:3px 10px;"></td>-->
                                <td align="right" style="padding:3px 10px;">{{ project.minuba_price | currency }}</td>
                                <td align="right" style="padding:3px 10px;">{{ project.minuba_price | currency }}</td>
                                <!--<td align="right" style="padding:3px 10px;">?</td>
                                <td align="right" style="padding:3px 10px;">?</td>-->
                                <td align="right" style="padding:3px 10px;">{{ project.invoices_total | currency }}</td>
                                <td align="right" style="padding:3px 10px;" :class="{'bad': (project.minuba_price - project.invoices_total) < 0}">{{ project.minuba_price - project.invoices_total | currency }}</td>
                            </tr>
                            <tr v-for="(budgetLine, index) in filteredBudgetLines" :key="index">
                                <td align="left" style="padding:3px 10px;">{{ budgetLine.type }}</td>
                                <!--<td align="right" style="padding:3px 10px;">{{ budgetLine.number }}</td>-->
                                <td align="right" style="padding:3px 10px;">{{ budgetLine.proposal_cost | currency }}</td>
                                <td align="right" style="padding:3px 10px;">{{ budgetLine.order_cost | currency }}</td>
                                <!--<td align="right" style="padding:3px 10px;">{{ budgetLine.adjustment_cost | currency }}</td>
                                <td align="right" style="padding:3px 10px;">?</td>-->
                                <td align="right" style="padding:3px 10px;">{{ budgetLine.expended_cost | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-style:italic;" :class="{'bad': (budgetLine.order_cost - budgetLine.expended_cost) < 0}">{{ budgetLine.order_cost - budgetLine.expended_cost | currency }}</td>
                            </tr>
                            <tr v-if="notBudgetted() > 0">
                                <td align="left" style="padding:3px 10px;">Ikke budgetteret</td>
                                <!--<td align="right" style="padding:3px 10px;">{{ budgetLine.number }}</td>-->
                                <td align="right" style="padding:3px 10px;"></td>
                                <td align="right" style="padding:3px 10px;"></td>
                                <!--<td align="right" style="padding:3px 10px;">{{ budgetLine.adjustment_cost | currency }}</td>
                                <td align="right" style="padding:3px 10px;">?</td>-->
                                <td align="right" style="padding:3px 10px;">{{ notBudgetted() | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-style:italic;">{{ notBudgetted() | currency }}</td>
                            </tr>
                            <tr>
                                <td colspan="8" style="height:0;padding:0;margin:0;">&nbsp;</td>
                            </tr>
                            <tr>
                                <td align="left" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">Omkostning</td>
                                <!--<td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;"></td>-->
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ sum(minubaBudget.budget_lines, 'proposal_cost') | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ sum(minubaBudget.budget_lines, 'order_cost') | currency }}</td>
                                <!--<td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ sum(minubaBudget.budget_lines, 'adjustment_cost') | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">?</td>-->
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted() | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;font-style:italic;" :class="{'bad': (sum(minubaBudget.budget_lines, 'order_cost') - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted())) < 0}">{{ sum(minubaBudget.budget_lines, 'order_cost') - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted()) | currency }}</td>
                            </tr>
                            <tr>
                                <td align="left" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">Dækningsbidrag</td>
                                <!--<td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;"></td>-->
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ project.minuba_price - sum(minubaBudget.budget_lines, 'proposal_cost') | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ project.minuba_price - sum(minubaBudget.budget_lines, 'order_cost') | currency }}</td>
                                <!--<td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ project.minuba_price - sum(minubaBudget.budget_lines, 'adjustment_cost') | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">?</td>-->
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ project.invoices_total - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted()) | currency }}</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;font-style:italic;" :class="{'bad': ((project.invoices_total - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted())) - (project.minuba_price - sum(minubaBudget.budget_lines, 'order_cost'))) < 0}">{{ (project.invoices_total - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted())) - (project.minuba_price - sum(minubaBudget.budget_lines, 'order_cost')) | currency }}</td>
                            </tr>
                            <tr>
                                <td align="left" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">Dækningsgrad</td>
                                <!--<td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;"></td>-->
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ ccp(project.minuba_price, (project.minuba_price - sum(minubaBudget.budget_lines, 'proposal_cost'))) }} %</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ ccp(project.minuba_price, (project.minuba_price - sum(minubaBudget.budget_lines, 'order_cost'))) }} %</td>
                                <!--<td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">{{ ((project.minuba_price - sum(minubaBudget.budget_lines, 'adjustment_cost')) / project.minuba_price) * 100 | rounded }} %</td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">?</td>-->
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;">
                                    <span v-if="closed">
                                        {{ ccp(project.invoices_total, (project.minuba_price - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted()))) }} %
                                    </span>
                                    <span v-else>-</span>
                                </td>
                                <td align="right" style="padding:3px 10px;font-weight:600;border-top:1px solid #172b43;font-style:italic;">
                                    <span v-if="closed">
                                        {{ ccp(project.invoices_total, (project.minuba_price - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted()))) - ccp(project.minuba_price, (project.minuba_price - sum(minubaBudget.budget_lines, 'order_cost'))) }} %
                                    </span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display:flex;justify-content:space-around;text-align:center;">
                        <div v-if="!closed">
                            <div style="margin-top:20px;font-weight:600;">
                                <span v-if="closed">
                                    Lønsomhed: {{ project.invoices_total - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted()) | currency }}
                                </span>
                                <span v-else>
                                    Færdiggørelsesgrad: {{ Math.round(project.completion_rate) }} %
                                </span>
                            </div>
                            <div style="margin-top:10px;">
                                <div v-if="closed" style="display:inline-block;position:relative;height:16px;width:100px;background:#ddd;border-radius:100px;overflow:hidden;box-shadow:0px 5px 15px rgba(0,0,0,0.15);">
                                    <!--<div :style="`height:16px;background:${project.completion_rate > 99 ? '#FF5252' : '#4CAF50'};width:${Math.ceil((100 / 100) * project.completion_rate)}px;max-width:100px;`">&nbsp;</div>-->
                                    <div style="height:16px;background:#4CAF50;" v-if="(project.invoices_total - (sum(minubaBudget.budget_lines, 'expended_cost') + notBudgetted())) > 0">
                                        
                                    </div>
                                    <div style="height:16px;background:#FF5252;" v-else>
                                        
                                    </div>
                                </div>
                                <div v-else style="display:inline-block;position:relative;height:16px;width:100px;background:#ddd;border-radius:100px;overflow:hidden;box-shadow:0px 5px 15px rgba(0,0,0,0.15);">
                                    <div :style="`height:16px;background:${project.completion_rate > 99 ? '#FF5252' : project.completion_rate > 80 ? '#FFA000' : '#4CAF50'};width:${Math.ceil((100 / 100) * project.completion_rate)}px;max-width:100px;`">&nbsp;</div>
                                </div>
                            </div>
                            <div v-if="!closed" style="margin-top:10px;">
                                <span style="font-size:10px;font-weight:normal;">Realiserede ift. budgetterede omkostninger</span>
                            </div>
                        </div>
                        <div v-if="closed">
                            <div style="margin-top:20px;font-weight:600;">
                                DB pr. time
                            </div>
                            <div>
                                <div
                                    v-if="project.coverage_per_hour !== null"
                                    class="coverage-indicator"
                                    :class="{'bad': project.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(project.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(project.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                />
                                {{ project.coverage_per_hour | currency }} 
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div v-if="loading">
                        Indlæser ...
                    </div>
                    <div v-else>
                        Hov, vi kunne ikke hente budgettet.
                    </div>
                </div>

            </template>
        </v-popover>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .bad {
        color: $color--bad;
    }

    .tooltip-target {

        i {
            opacity: 0.5;
        }

        &:hover {
            
            i {
                opacity: 1;
            }
        }
    }

    .line {
        min-width: 250px;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        margin-bottom: $margin--small / 2;
        font-weight: 600;

        .good {
            color: $color--good;
        }

        .bad {
            color: $color--bad;
        }

        &.total {
            color: inherit;
            margin-bottom: 0;
            font-weight: 700;
        }
    }

</style>

<script>
import * as projectService from '@/services/projectService'

export default {
    props: {
        project: { type: Object },
        closed: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            loading: false,
            show: false,
            options: {
                popover: {
                    defaultClass: 'mb-tooltip',
                    defaultBaseClass: 'mb-tooltip',
                    trigger: 'hover'
                }
            },
            minubaBudget: null
        }
    },
    mounted () {
        // this.getData()
    },
    methods: {
        getData () {
            this.minubaBudget = null
            this.loading = true
            projectService.getBudget(this.project.uuid, {}, response => {
                this.minubaBudget = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        sum (arr, key) {
            return arr.reduce((a, b) => a + (Number(b[key]) || 0), 0)
        },
        ccp (revenue, expenses) {
            // Calculate Coverage Percent (CCP)
            if (revenue > 0 && expenses > 0) {
                return Math.round((expenses / revenue) * 100)
            }
            return 0
        },
        notBudgetted () {
            let value = this.project.total_expenses - this.sum(this.minubaBudget.budget_lines, 'expended_cost')
            return value > 0 ? value : 0
        }
    },
    computed: {
        filteredBudgetLines () {
            if (this.minubaBudget && this.minubaBudget.budget_lines) {
                return this.minubaBudget.budget_lines.filter(x => x.proposal_cost || x.order_cost || x.expended_cost)
            }
            return []
        }
    },
    watch: {
        show (newVal, oldVal) {
            if (!this.minubaBudget) {
                if (oldVal === false && newVal === true) {
                    this.getData()
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// MinubaBudgetTooltip.vue?65f8ad8e